import React from 'react'
import {
    getBillingInformation,
    setBillingInformation,
    getCuitInformation,
    getTaxingCategoryList,
} from '../../../helpers/restHelpers'
import Loader from '../../loaders'
import { Button, IconButton, TextField } from '@material-ui/core/index'
import { strings } from '../../../localization/strings'
import SearchIcon from '@material-ui/icons/SearchOutlined'
import ClearIcon from '@material-ui/icons/ClearOutlined'
import { CuitNumberFormat } from '../../../utils/formaters'

const style = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        padding: 10,
        maxWidth: 700,
        minWidth: 300,
        opacity: 0.87,
        fontFamily: 'neutra',
        fontSize: '1.1428571428571428rem',
    },
    sectionLabel: {
        margin: 'auto',
        fontWeight: 400,
        marginTop: 0,
        marginBottom: 20,
        fontSize: '1.6428571428571428rem',
    },
}

class Component extends React.Component {
    initialState = {
        cuitTmp: '',
        cuit: '',
        businessName: '',
        taxingCategoryId: '',
        isValidated: false,
    }

    state = {
        loader: false,
        taxingCategoryList: [],
        ...this.initialState,
    }

    clearCuit = () => {
        this.setState({ ...this.initialState })
    }

    validateCuit = () => {
        if (!this.state.cuitTmp) return
        this.setState({ loader: true })
        getCuitInformation(this.state.cuitTmp)
            .then((x) => this.setState({ ...x, cuitTmp: x.cuit }))
            .catch((x) => {
                this.setState({
                    cuit: this.state.cuitTmp,
                    businessName: this.initialState.businessName,
                    taxingCategoryId: this.initialState.taxingCategoryId,
                    isValidated: this.initialState.isValidated,
                })
                window.showDialog(x)
            })
            .finally(() => this.setState({ loader: false }))
    }

    getBillingInfo = () => {
        this.setState({ loader: true })
        getBillingInformation()
            .then((x) => {
                this.setState({
                    ...x,
                    cuitTmp: x.cuit,
                    editable: !x.isValidated,
                })
                if (!x.isValidated)
                    window.showDialog({
                        message: strings.billingInformation_oldCuitNotFound,
                    })
            })
            .catch((x) => window.showDialog(x))
            .finally(() => this.setState({ loader: false }))
    }

    submitOk = () => {
        const { cuit, businessName, taxingCategoryId, isValidated } = this.state
        this.setState({ loader: true })
        setBillingInformation({
            cuit,
            businessName,
            taxingCategoryId,
            isValidated,
        })
            .then(() =>
                window.showDialog(
                    {
                        title: strings.billingInformation_successTitle,
                        message: strings.saveSuccessDialog,
                    },
                    this.getBillingInfo
                )
            )
            .catch(() =>
                window.showDialog(
                    { message: strings.saveErrorDialog },
                    this.getBillingInfo
                )
            )
    }

    submitCancel = () => {
        this.getBillingInfo()
    }

    componentDidMount() {
        this.getBillingInfo()
        getTaxingCategoryList()
            .then((x) => this.setState({ taxingCategoryList: x || [] }))
            .catch((x) => window.showDialog(x))
    }

    render() {
        const {
            loader,
            editable,
            cuitTmp,
            taxingCategoryList,
            cuit,
            businessName,
            taxingCategoryId,
            isValidated,
        } = this.state
        if (!taxingCategoryList.length || loader) return <Loader />

        var taxingCategoryName = taxingCategoryList.find(
            (x) => x.id === taxingCategoryId
        )
        taxingCategoryName = taxingCategoryName ? taxingCategoryName.name : ''

        return (
            <div style={style.container}>
                <div style={style.sectionLabel}>
                    {strings.billingInformation_title}
                </div>

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'baseline',
                    }}
                >
                    <TextField
                        style={{ marginTop: 20, maxWidth: 150 }}
                        InputLabelProps={{ shrink: true }}
                        fullWidth
                        InputProps={{
                            inputComponent: CuitNumberFormat,
                            readOnly: !editable || isValidated,
                        }}
                        label={strings.billingInformation_cuit}
                        placeholder={strings.billingInformation_cuitPlaceholder}
                        value={cuitTmp}
                        onChange={(e) =>
                            this.setState({ cuitTmp: e.target.value })
                        }
                    />
                    {!isValidated ? (
                        <IconButton
                            color="primary"
                            aria-label="upload picture"
                            component="span"
                            onClick={this.validateCuit}
                        >
                            <SearchIcon />
                        </IconButton>
                    ) : !editable ? null : (
                        <IconButton
                            color="primary"
                            aria-label="upload picture"
                            component="span"
                            onClick={this.clearCuit}
                        >
                            <ClearIcon />
                        </IconButton>
                    )}
                    {cuit && !isValidated ? (
                        <div
                            style={{
                                color: 'rgb(97, 26, 21)',
                                backgroundColor: 'rgb(253, 236, 234)',
                                flexGrow: 1,
                                fontSize: '75%',
                                textAlign: 'center',
                            }}
                        >
                            {strings.billingInformation_failValidation}
                        </div>
                    ) : (
                        <div style={{ flexGrow: 1 }} />
                    )}
                </div>

                {!isValidated ? null : (
                    <>
                        <TextField
                            style={{ marginTop: 20 }}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            variant={'filled'}
                            InputProps={{ readOnly: true }}
                            label={strings.billingInformation_businessName}
                            value={businessName}
                        />
                        <TextField
                            style={{ marginTop: 20 }}
                            InputLabelProps={{ shrink: true }}
                            fullWidth
                            variant={'filled'}
                            InputProps={{ readOnly: true }}
                            label={strings.billingInformation_taxingCategory}
                            value={taxingCategoryName}
                        />
                    </>
                )}

                {!editable || !isValidated ? null : (
                    <>
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                justifyContent: 'space-between',
                                marginTop: 20,
                            }}
                        >
                            <div style={{ flexGrow: 1 }} />
                            <Button
                                color="primary"
                                variant="contained"
                                size="small"
                                onClick={this.submitCancel}
                            >
                                {strings.dialogCancelLabel}
                            </Button>
                            <div style={{ width: 100 }} />
                            <Button
                                color="primary"
                                variant="contained"
                                size="small"
                                onClick={this.submitOk}
                            >
                                {strings.dialogOkLabel}
                            </Button>
                        </div>
                    </>
                )}
            </div>
        )
    }
}

export default Component
